import { RootState } from "../../../../store";
import { ResourceExplorerData } from "../../../../../services/cloudchipr.api";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";

export const resourceExplorerDataSelector = (
  state: RootState,
): ResourceExplorerData | undefined => {
  return resourceExplorerStateSelector(state).data ?? undefined;
};
